var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('cheader'),_c('div',{staticClass:"main-wrapper"},[_c('navBar'),_c('div',{ref:"main",staticClass:"main",attrs:{"id":"main"}},[_c('breadcrumb'),_c('appMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }